import React, { ChangeEvent, useState } from "react";
import { ErrorMessage, Field, useField, useFormikContext } from "formik";
import { ErrorModalComponent } from "@me-pos/error-modal";
import i18next from "i18next";
import { useGetCurrencyMenuItemQuery } from "@me-team/host/main/menu/graphql/menu.hooks";
import { useReactiveVar } from "@apollo/client";
import { currentCompanyIdVar } from "@me-team/host/main/globalVar/state";

interface PriceInputProps {
    name: string;
    placeholder: string;
    initialValue?: number;
    id: string;
    disabled?: boolean;
}

const PriceInput: React.FC<PriceInputProps> = ({ name, placeholder, initialValue, id, disabled }) => {
    const currentCompanyId = useReactiveVar(currentCompanyIdVar);
    const [isErrorModalOpen, setIsErrorModalOpen] = useState<number>(null);
    const initialValuePrice = initialValue ? initialValue.toString() : "";
    const { setFieldValue, setFieldTouched } = useFormikContext();
    const [, meta] = useField(name);
    const [price, setPrice] = useState(initialValuePrice);

    const { data: currenciesData } = useGetCurrencyMenuItemQuery({
        variables: { companyId: Number(currentCompanyId) },
        skip: !currentCompanyId,
    });

    const currencySign = currenciesData?.user?.company?.currency?.currencySign;

    const handlePriceChange = (e: ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        const value = e.target.value.trim();
        const regex = /^(?!0\d)\d{0,6}(\.\d{0,2})?$/;
        if (regex.test(value) || value === "") {
            setPrice(value);
        }
    };

    const handleBlurPrice = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.trim();
        if (value === "") {
            setPrice("");
            setFieldTouched(name, true, true);
            setFieldValue(name, null);
        } else {
            const numericPrice = parseFloat(value);

            if (!isNaN(numericPrice)) {
                const formattedPrice = numericPrice.toFixed(2);
                setPrice(formattedPrice);
                setFieldValue(name, parseFloat(formattedPrice));
            } else {
                setPrice("");
                setFieldValue(name, null);
            }
        }
    };
    return (
        <>
            <div className="position-relative w-100">
                <Field
                    name={name}
                    type="text"
                    id={id}
                    placeholder={placeholder}
                    value={price !== null ? price.toString() : ""}
                    className={`form-control ${meta.touched && meta.error ? "is-invalid" : ""}`}
                    onBlur={handleBlurPrice}
                    onChange={handlePriceChange}
                    disabled={disabled}
                />
                <span
                    className={`position-absolute end-0 top-0 bottom-0 d-flex align-items-center text-dark me-6 lh-1 ${meta.error ? "d-none" : ""}`}
                    style={{ transform: "translateY(1px)" }}
                >
                    {currencySign}
                </span>
                <ErrorMessage name={name}>{(msg) => <div className="invalid-feedback">{msg}</div>}</ErrorMessage>
            </div>
            {isErrorModalOpen ? (
                <ErrorModalComponent
                    i18n={i18next}
                    onClose={() => {
                        setIsErrorModalOpen(null);
                    }}
                    isOpen={!!isErrorModalOpen}
                    currentError={isErrorModalOpen}
                />
            ) : null}
        </>
    );
};

export default PriceInput;
